import React from 'react'
import NavbarBlue from '../../components/NavbarBlue/NavbarBlue'
import { useBasePath } from '../../customHooks/useBasePath';
import { Footer } from '@exactian/exactian-components';
import { APP_VERSION, getDataUserByKey } from '../../helpers/helpers';

const MainLayout = ({ children, className = 'col-xl-4 col-lg-7 col-sm-9 mt-3' }) => {

    const path = useBasePath();
    const routesWithoutNavBar = ['', '/login', '/loginCC'];
    const language = 'es';
    const showNavBar = !routesWithoutNavBar.includes(path);

    const appVersion = APP_VERSION;
    const year = getDataUserByKey("year") || "";
    const partner = getDataUserByKey("partner") || "";

    return (
        <div className='d-flex flex-column min-vh-100' style={{ overflowX: 'hidden' }}>
            {showNavBar && (
                <NavbarBlue />
            )}
            <div className="row justify-content-center flex-grow-1">
                <div className={className}>
                    {children}
                </div>
            </div>
            {showNavBar && (
                <div className='mt-auto'>
                    <Footer
                        language={language}
                        showPrivacyPolicy={false}
                        appVersion={appVersion}
                        partner={partner}
                        year={year}
                    />
                </div>
            )}
        </div>
    )
}

export default MainLayout